import events from "./trackingEvents";
const isLocal = false;
const apiURL = isLocal ? 'http://charus-macbook-pro-2.local:8000/api/' : '/api/';

export function getAnswer(question) {
  return fetch(apiURL + `getAnswer?question=${question}`)
    .then(response => response.json());
}

export function addGraph(name, nodes) {
  return fetch(apiURL + `addGraph?name=${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(nodes)
  })
  .then(response => response.text());
}

export function expandNode(question, group, parent, graphName) {
  events.expandNodeEvent(graphName + ' ' + parent);
  return fetch(apiURL + `expandNode?question=${question}&group=${group}&parent=${parent}&graphName=${graphName}`)
    .then(response => response.json());
}

export function sendFeedback(feedback) {
  console.log(feedback);
  return fetch(apiURL + 'addFeedback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(feedback)
  })
  .then(response => response.text());
}

export function getAllGraphNames() {
  return fetch(apiURL + 'getAllGraphNames')
    .then(response => response.json());
}

export function getGraph(name) {
  return fetch(apiURL + `getGraph?name=${name}`)
    .then(response => response.json());
}

export function getDefinition(question, nodeId, graphName ) {
  events.singleClickEvent(graphName + ' ' + nodeId);
  return fetch(apiURL + `getDefinition?question=${question}&nodeId=${nodeId}&graphName=${graphName}`)
    .then(response => response.text());
}

export function registerGraphReaction(graphName, reaction) {
  if (reaction !== 'like' && reaction !== 'dislike') {
    return new Promise((resolve, reject) => {
      reject('Invalid reaction');
    });
  }

  return fetch(apiURL + `registerGraphReaction?graphName=${graphName}&reaction=${reaction}`)
    .then(response => response.text());
}

export function getGraphReactions(graphName) {
  return fetch(apiURL + `getGraphReactions?graphName=${graphName}`)
    .then(response => response.json());
}